import { Flex } from "shared/ui/flex";
import { Typography } from "shared/ui/typography";
import { HeaderNameContainer } from "../styles";

export const AllSlotsModalHeader = () => {
  return (
    <Flex $gap="15px" $alignItems="center">
      <HeaderNameContainer>
        <Typography
          isBold={true}
          truncate={true}
          mode={'h2'}
          colorVariant={'main'}
        >
          Доступные слоты
        </Typography>
      </HeaderNameContainer>
    </Flex>
  );
};
